/**
 * Client build label for cross-tab BroadcastChannel compatibility checks.
 * Set at compile time via vite.config define (__APP_BUILD_VERSION__).
 */
export const APP_BUILD_VERSION: string =
  typeof __APP_BUILD_VERSION__ !== "undefined" ? __APP_BUILD_VERSION__ : "0.0.0";
